// 英语
export const common = {
  cancel:"Cancel",
  confirm:"Confirm",
  country:"Country"
};
// 订单列表页面
export const orderList = {
  title:"Order List",
};

// 查询页面
export const cardLoop = {
  cardTitle:"SIM card ICCID number",
  cardDesc:"Enter the SIM card ICCID number in the input box.",
  query:"Search",
  title:"IOT SIM card platform",
};

// 详情页面
export const cardInfo = {
  title:"card information",
  msisdn:"MSISDN:",  
  iccid:"ICCID",
  expiration:"Expiration",//过期时间
  status:"Status",
  refresh:"Refresh",//刷新
  residualFlow:"ResidualFlow",
  totalFlow:"Total",
  used:"Used",
  lists:["Using","Unused","Done"],//1 生效中 2 未生效 3.已失效
  validity:"validity",
  skuUsed:"Used",
  skuTotal:"Total",
  recharge:"TopUp",//去充值
};

// 选套餐页面
export const cardPlans = {
  title:"Package List",
  buyPlan:'Buy Plan',
  select:"Choose a plan",//未选套餐的提示
  orderList:"Order List",
  userAgreement:"User Agreement",
  price:"Package Price",
  flowCount:"Total flow",
  validityTime:"Effective date",
  switchCountryName:"Usable area",
  productDesc:"Package Description",
  productDescText:"Advance charge",
  paymentMethod:"Payment method",
  checkUserAgreementMsg:"Please check the user agreement",
  payErrorMsg:"The receiving account does not support RMB payment",
  payBtnText:"Buy With",
};


// 完成支付或取消支付
export const cardPayEnd = {
  title:"Payment results",
  Details:"Details",//返回详情
}

// 位置标签
export const placeTitle = "Country";

export const country = {
  America:'America',
  HongKong:'HongKong',
  Thailand:'Thailand',
  Philippines:'Philippines',
  Macao:'Macao'
}


// 国家名称
export const China = "China"
export const America = "America"
export const HongKong = "Hong Kong"







